import { render, staticRenderFns } from "./PeeringForm.vue?vue&type=template&id=5f8378af"
import script from "./PeeringForm.vue?vue&type=script&lang=js"
export * from "./PeeringForm.vue?vue&type=script&lang=js"
import style0 from "./PeeringForm.vue?vue&type=style&index=0&id=5f8378af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports